import { render, staticRenderFns } from "./UpDownBar.vue?vue&type=template&id=1cd4420c&"
import script from "./UpDownBar.vue?vue&type=script&lang=ts&"
export * from "./UpDownBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports